import { ITranscriptionSourceFileProvider, ITranscriptionSourceFile } from "./interfaces/ITranscriptionSourceFileProvider";
import { IDocumentStorageTranscriptionDescriptor } from "./interfaces/IDocumentStorageTranscriptionDescriptor";
import { IAuthenticationProvider } from "./interfaces/IAuthenticationProvider";
import * as parsing from './DocumentStorageTranscriptionManagerParsing'
import { MakeOneDriveItemGraphRequest } from "./ms-graph/GraphApiCalls";
import { IOneDriveItemInfo, IOneDriveItem } from "./interfaces/IOneDriveItem";
import { TranscriptionSourceFileError, TranscriptionSourceFileErrors } from "./TranscriptionManagerErrors";
import * as GraphClientInitOptions from './ms-graph/GraphClientInitOptions';
import { Client, Options } from '@microsoft/microsoft-graph-client';
import { IsAuthError } from "./office-js/auth/AuthErrors";

export class OneDriveTranscriptionSourceFileProvider implements ITranscriptionSourceFileProvider {
    private oneDriveItem: IOneDriveItem;
    private authProvider: IAuthenticationProvider;

    public constructor(descriptor: IDocumentStorageTranscriptionDescriptor, authProvider: IAuthenticationProvider) {
        this.oneDriveItem = descriptor.audioOneDriveItem;
        this.authProvider = authProvider;
    }

    private InitGraphClient(): Client {
        let options: Options = GraphClientInitOptions.GetAuthOptions(this.authProvider);
        options.fetchOptions = { cache: 'reload' };
        return Client.init(options);
    }

    private async GetTranscriptionSourceFileFromOneDriveItem(oneDriveItem: IOneDriveItem): Promise<ITranscriptionSourceFile> {
        try {
            const graphClient: Client = this.InitGraphClient();

            const response = await MakeOneDriveItemGraphRequest(graphClient, oneDriveItem.driveId, oneDriveItem.itemId);
            const audioItemInfo: IOneDriveItemInfo = parsing.ParseItemInfoFromGraphResponse(response);
            
            if (audioItemInfo.downloadUrl == null )
                throw new Error("Didn't get downloadUrl for audio file form Graph API");

            return {
                fileName: audioItemInfo.name,
                audioUrl: audioItemInfo.downloadUrl,
                permanentAudioUrl: audioItemInfo.webUrl
            };
        } catch (error) {
            if (error.code == "itemNotFound" || error.code == "accessDenied" || IsAuthError(error))
                throw new TranscriptionSourceFileError(TranscriptionSourceFileErrors.SourceFileNotFound, "Couldn't find source file");
            throw error;
        }
    }


    GetSourceFile(): Promise<ITranscriptionSourceFile> {
        return this.GetTranscriptionSourceFileFromOneDriveItem(this.oneDriveItem);
    }
}